import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { DOLLY_URL, M_POST } from '@/utils/api';

@Module({ name: 'legendofdolly' })
export default class LegendOfDolly extends VuexModule {
  @Action({ rawError: true })
  async FetchDollyReport(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: DOLLY_URL,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch dolly report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch dolly report failed');
    }
  }
}
